import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/fr";

dayjs.locale("fr");

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export { dayjs };

export function formatApiError(e) {
  const detail = e?.response?.data?.detail ?? e?.message;
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const euro = (n) =>
  `${Number(n).toLocaleString("fr-FR", { maximumFractionDigits: 0 })} €`;
